export default function VerticalLine() {
  return (
    <svg
      width="1"
      height="53"
      viewBox="0 0 1 53"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Vertical Line</title>
      <line
        x1="0.5"
        y1="1"
        x2="0.499998"
        y2="52"
        stroke="url(#paint0_linear_45_146182)"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_45_146182"
          x1="-1.91933e-06"
          y1="0.5"
          x2="-11.8617"
          y2="49.6365"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FBFBFB" stop-opacity="0" />
          <stop offset="0.484281" stop-color="#FBFBFB" />
          <stop offset="1" stop-color="#FBFBFB" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
